export class AlloyConfig {
  public stepUpAnchor?: string;
  public anchorIsDedicated?: boolean;
  public initParams: {
    production: boolean;
    color?: { primary: string; secondary: string };
    showHeader?: boolean;
    customStyle?: {
      theme: {
        primaryColor?: string;
        backgroundColor?: string;
        textColor?: string;
        borderRadius?: string;
        iconColor?: string;
        successColor?: string;
        errorColor?: string;
      };
      componentOverride?: {
        PrimaryButton?: {
          default?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
          };
          hover?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
          };
          focus?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
          };
        };
        ExitButton?: {
          default?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
          };
          hover?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
          };
          focus?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
          };
        };
        PictureButton?: {
          default?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
          };
          hover?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
          };
          focus?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
          };
        };
        SelectorButton?: {
          default?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
            iconColor?: string;
          };
          hover?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
            iconColor?: string;
          };
          focus?: {
            backgroundColor?: string;
            textColor?: string;
            borderRadius?: string;
            border?: string;
            boxShadow?: string;
            iconColor?: string;
          };
        };
        Header?: {
          default?: {
            backgroundColor?: string;
            textColor?: string;
            border?: string;
            boxShadow?: string;
            borderRadius?: string;
          };
        };
        HelpBanner?: {
          default?: {
            backgroundColor?: string;
            textColor?: string;
            border?: string;
            boxShadow?: string;
            borderRadius?: string;
            iconColor?: string;
          };
        };
        PhoneInput?: {
          default?: {
            backgroundColor?: string;
            textColor?: string;
            border?: string;
            boxShadow?: string;
            borderRadius?: string;
          };
        };
      };
    };
  };
}
